var map = {
	"./5 degree error.jpg": 5984,
	"./blackbody.jpg": 5985,
	"./electric.jpg": 5986,
	"./greys.jpg": 5987,
	"./hot.jpg": 5988,
	"./jet.jpg": 260,
	"./rdbu.jpg": 5989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 518;